var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.539)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd7c7c",
    d: "M1.415,302H.462a.461.461,0,0,0-.462.462V308a.461.461,0,0,0,.462.462h.954A1.386,1.386,0,0,0,2.8,307.077v-3.692A1.386,1.386,0,0,0,1.415,302Z",
    transform: "translate(0 -302)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd7c7c",
    d: "M187.077,0a5.069,5.069,0,0,0-3.923,8.289,4.119,4.119,0,0,1,1.588.868.363.363,0,0,0,.231.074h1.643a1.8,1.8,0,0,1,1.523.812A5.078,5.078,0,0,0,187.077,0Zm.471,7.3h-.009v.545a.462.462,0,1,1-.923,0V7.3a1.831,1.831,0,0,1-.84-.6.459.459,0,1,1,.7-.591c.249.3.526.406.757.323a.461.461,0,0,0-.157-.9,1.383,1.383,0,0,1-.535-2.658c.018-.009.046-.009.074-.018V2.308a.462.462,0,1,1,.923,0v.554a1.815,1.815,0,0,1,.683.406.463.463,0,1,1-.646.665.624.624,0,0,0-.674-.2.46.46,0,0,0,.175.886,1.384,1.384,0,0,1,.471,2.686Z",
    transform: "translate(-182)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.969 8.361)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd7c7c",
    d: "M132.892,297.318a.846.846,0,0,0-.212-.231.914.914,0,0,0-1.246.092l-2.1,2.418-.065.074a1.362,1.362,0,0,1-1.015.443h-3.612a.462.462,0,1,1,0-.923h2.846a.926.926,0,0,0,.923-.923v-.009a.924.924,0,0,0-.923-.914h-1.7a1.271,1.271,0,0,1-.812-.3,3.235,3.235,0,0,0-3.978-.212v5.677a10.654,10.654,0,0,0,2.806.379h4.148a3.235,3.235,0,0,0,2.585-1.292l2.215-2.954A1.222,1.222,0,0,0,132.892,297.318Z",
    transform: "translate(-121 -296.246)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/paymentFailed.25b7a52a08876229dbf59a1f3fe0049e.svg";
export { ForwardRef as ReactComponent };